const FindStructureData =async (apiHandler,endpoint, authToken, setstructureTypeList )=>{
    const result = await apiHandler({
        url: endpoint.MASTER_STRUCTURE_TYPE_FINDALL,
        authToken: authToken,
      });
      if (result?.data?.error_code) {
        console.log("Error in MasterStructure Api");
      } else {
        //Sending Master Structure Type data in Redux
        setstructureTypeList(result?.data)
      }
}

export default FindStructureData;